export const formatHTMLYoutubeEmbed = (embedContent: string) => {
  let regex =
    /(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be)\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=)([a-zA-Z0-9_-]+)(?=[^\w-]|$)/;
  let match = embedContent?.match(regex);
  if (!match) return embedContent;
  const videoId = match[1];
  let newUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&rel=0&controls=0&rel=0&modestbranding=0&showinfo=0`;
  let output = embedContent?.replace(/src="[^"]+"/, `src="${newUrl}"`);
  return output;
};
